import type { UploadCustomRequestOptions } from 'naive-ui'
import { useApiFetch } from '@/server/request'
import type { FetchResponseType } from '@/server/request/types'
import { useNotification } from '@/composables/useNotification'
import { FILE_UPLOAD_TYPE } from '@/shared/types'
import { UPLOAD_URL } from '@/shared/constants'

export function uploadFile(
  file: Blob | File,
  data: Record<string, string> & { code: FILE_UPLOAD_TYPE } = { code: FILE_UPLOAD_TYPE.other },
) {
  const formData = new FormData()

  formData.append('file', file)
  if (!data.code || !Object.values(FILE_UPLOAD_TYPE).includes(data.code))
    throw new Error('上传文件码错误')

  if (data) {
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key])
    })
  }

  return useApiFetch<FetchResponseType<string>>(UPLOAD_URL, {
    method: 'POST',
    body: formData,
    timeout: 0,
  })
}

export async function customSingleFileUpdate({
  file,
  data,
  onFinish,
  onError,
}: UploadCustomRequestOptions) {
  if (!file.file)
    throw new Error('未选择上传文件')

  // show loading toast
  uploadingToast()

  try {
    const response = await uploadFile(file.file, { code: FILE_UPLOAD_TYPE.other, ...(data || {}) })
    uploadSuccess()
    onFinish()
    return response
  }
  catch (error) {
    console.error(error)
    uploadFail()
    onError()
  }
}

function uploadingToast(text = '图片上传中') {
  return useNotification.info({
    title: text,
    duration: 0,
  })
}
function uploadSuccess(text = '图片上传成功') {
  useNotification.destroyAll()
  return useMessage.success(text, {
    duration: 1500,
    closable: true,
  })
}
function uploadFail(text = '图片上传失败') {
  useNotification.destroyAll()
  return useMessage.error(text, {
    duration: 1500,
    closable: true,
  })
}
